export enum StorageKey {
  CompanyId = 'CompanyId',
  Language = 'i18nextLng',
  Permissions = 'Permissions',
  Token = 'Token',
  SessionId = 'SessionId',
}
